// Re-export colors from shared package
export { colors } from '@sway-app/shared/src/style/colors';
